module.exports = __webpack_public_path__ + "images/fa-platform-snaps-mobile.png";